import type { RouteObject } from "react-router";
import { Reconciliation } from "./Reconciliation";
import { ReconciliationDispatch } from "./reconcillation-dispatch/ReconcillationDispatch";
import { ReconciliationInventory } from "./reconcillation-inventory/ReconcillationInventory";

/** The /reconciliation subtree: the reconciliation home, dispatch and inventory pages. */
export const reconciliationRoute: RouteObject = {
  path: "reconciliation",
  children: [
    { index: true, element: <Reconciliation /> },
    { path: "dispatch", element: <ReconciliationDispatch />},
    { path: "inventory", element: <ReconciliationInventory />},
  ],
};
